import React, { Component } from 'react';
import AppStore from '../../stores/app-store.js'
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';

import '../../grid.css';
import './GuardaHistoriaEAutor.css';

import { deepOrange500 } from 'material-ui/styles/colors';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

import AWS from 'aws-sdk';

const muiTheme = getMuiTheme({
    palette: {
        accent1Color: deepOrange500,
    },
});

class GuardaHistoriaEAutor extends Component {
    constructor() {
        super();
        this.guardar = this.guardar.bind(this);
        this.state = {
            nomeHistoria: '',
            nomeHistoriaErro: '',
            autores: '',
            autoresErro: '',
            email: '',
            emailErro: '',
            ddd: '',
            dddErro: '',
            telefone: '',
            telefoneErro: '',
            legendas: AppStore.legendas,
        }
        this.textoHistoria = '';
        this.guardados = [];
        this.onChangeLingua = this.onChangeLingua.bind(this);
    }

    static contextTypes = {
        router: React.PropTypes.object.isRequired
    }

    componentWillMount() {
        let tmp = localStorage.getItem("vdv_guardados");
        if (tmp) {
            this.guardados = tmp.split(",");
        }
        //this.textoHistoria = AppStore.getSequenciaHistorias().toString;
        this.textoHistoria = AppStore.getSequenciaHistorias();
        AppStore.addChangeLinguaListener(this.onChangeLingua);
        
    }

    componentWillUnmount() {
        AppStore.removeChangeLinguaListener(this.onChangeLingua);
    }


    onChangeLingua() {
        this.setState({
            legendas: AppStore.legendas,
        })
    }

    handleInputChange = (event) => {
        this.setState({
            nomeHistoria: event.target.value,
        });
    };

    handleInputChangeAutores = (event) => {
        this.setState({
            autores: event.target.value,
        });
    };

    handleInputChangeEmail = (event) => {
        this.setState({
            email: event.target.value,
        });
    };

    handleInputChangeTelefone = (event) => {
        this.setState({
            telefone: event.target.value,
        });
    };

    handleInputChangeDdd = (event) => {
        this.setState({
            ddd: event.target.value,
        });
    };

    guardar() {
        this.setState({
            nomeHistoriaErro: '',
            autoresErro: '',
            emailErro: '',
            dddErro: '',
            telefoneErro: '',
        });
        let len = 0;
        let erro = false;
        let eNumero = false;

        len = this.state.nomeHistoria.length;
        if (len === 0) {
            this.setState({
                nomeHistoriaErro: this.state.legendas.digitacaoObrigatoria,
            })
            erro = true;
        }

        len = this.state.autores.length;
        if (len === 0) {
            this.setState({
                autoresErro: this.state.legendas.digitacaoObrigatoria,
            })
            erro = true;
        }

        len = this.state.email.length;
        if (len === 0) {
            this.setState({
                emailErro: this.state.legendas.digitacaoObrigatoria,
            })
            erro = true;
        }
        if (len > 0) {
            let pos = this.state.email.indexOf("@");
            if (pos === -1) {
                this.setState({
                    emailErro: this.state.legendas.erroEmail,
                })
                erro = true;
            }
        }

        len = this.state.ddd.length;
        if (len === 0) {
            this.setState({
                dddErro: this.state.legendas.digitacaoObrigatoria,
            })
            erro = true;
        } else if (len !== 2) {
            this.setState({
                dddErro: this.state.legendas.obrigatoriosdoisdig,
            })
            erro = true;
        }
        eNumero = !/\D/.test(this.state.ddd);
        if (eNumero === false) {
            this.setState({
                dddErro: this.state.legendas.somenteNumeros,
            })
            erro = true;
        }

        len = this.state.telefone.length;
        if (len === 0) {
            this.setState({
                telefoneErro: this.state.legendas.digitacaoObrigatoria,
            })
            erro = true;
        } else if (len < 8 || len > 9) {
            this.setState({
                telefoneErro: this.state.legendas.obrigatoriosoitoounovedig,
            })
            erro = true;
        }
        eNumero = !/\D/.test(this.state.telefone);
        if (eNumero === false) {
            this.setState({
                telefoneErro: this.state.legendas.somenteNumeros,
            })
            erro = true;
        }

        if (erro === false) {

            ///////////////////////////////////////////////////////////////////////////

            var email = "site@vivaedeixeviver.org.br";
            //AWS.config.loadFromPath('../../config.json');
            AWS.config.update({ accessKeyId: 'AKIAIOE3XK5JWCKFK4PA', secretAccessKey: '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' });
            var ses = new AWS.SES({region:'us-east-1'});

            var corpo = "";
            corpo = corpo + "<h2>AUTORES</h2>";
            corpo = corpo + "<p>" + this.state.autores + "</p>"
            corpo = corpo + "<h2>EMAIL</h2>";
            corpo = corpo + "<p>" + this.state.email + "</p>";
            corpo = corpo + "<h2>TELEFONE</h2>";
            corpo = corpo + "<p>(" + this.state.ddd + ") " + this.state.telefone + "</p>";
            corpo = corpo + "<h2>TITULO</h2>";
            corpo = corpo + "<p>" + this.state.nomeHistoria + "</p>";
            corpo = corpo + "<h2>TEXTO</h2>";
            corpo = corpo + "<p>" + this.textoHistoria + "</p>";

            var ses_mail = "From: 'Eu Conto' <" + email + ">\n";
            ses_mail = ses_mail + "To: " + email + "\n";
            ses_mail = ses_mail + "Subject: Historia Doada\n";
            ses_mail = ses_mail + "MIME-Version: 1.0\n";
            ses_mail = ses_mail + "Content-Type: multipart/mixed; boundary=\"NextPart\"\n\n";
            ses_mail = ses_mail + "--NextPart\n";
            ses_mail = ses_mail + "Content-Type: text/html; charset=us-ascii\n\n";
            ses_mail = ses_mail + corpo;
            //ses_mail = ses_mail + "--NextPart--";

            var params = {
                RawMessage: { Data: new Buffer(ses_mail) },
                Destinations: [email],
                Source: "'Eu Conto' <" + email + ">'"
            };

            ses.sendRawEmail(params, function (err, data) {
                if (err) {
                    console.log(err);
                }
                else {
                    console.log(data);
                }
            });






            ///////////////////////////////////////////////////////////////////////////

            this.guardados.push(this.state.nomeHistoria);
            let tmp = this.guardados.toString();
            localStorage.setItem("vdv_guardados", tmp);
            localStorage.setItem(this.state.nomeHistoria, this.textoHistoria);
            this.context.router.push('/capa');
        }
    }

    render() {
        return (
            <MuiThemeProvider muiTheme={muiTheme}>
                <div className="GuardaHistoria">
                    <div className="ui-g">
                        <div className="ui-g-12">
                            <TextField
                                style={{ maxWidth: '90%', fontFamily: 'OpenSans', color: 'white' }}
                                textareaStyle={{ color: 'white' }}
                                inputStyle={{ color: 'white' }}
                                hintStyle={{ color: 'white' }}
                                hintText={this.state.nomeHistoria}
                                errorText={this.state.nomeHistoriaErro}
                                floatingLabelText={this.state.legendas.nomeHistoria}
                                floatingLabelStyle={{ color: 'white' }}
                                multiLine={false}
                                rows={1}
                                rowsMax={1}
                                value={this.state.nomeHistoria}
                                onChange={this.handleInputChange}
                            />
                        </div>
                        <div className="ui-g-12">
                            <TextField
                                style={{ maxWidth: '90%', fontFamily: 'OpenSans', color: 'white' }}
                                textareaStyle={{ color: 'white' }}
                                inputStyle={{ color: 'white' }}
                                hintStyle={{ color: 'white' }}
                                hintText={this.state.autores}
                                errorText={this.state.autoresErro}
                                floatingLabelText={this.state.legendas.autores}
                                floatingLabelStyle={{ color: 'white' }}
                                multiLine={true}
                                rows={4}
                                rowsMax={4}
                                value={this.state.autores}
                                onChange={this.handleInputChangeAutores}
                            />
                        </div>
                        <div className="ui-g-12">
                            <TextField
                                style={{ maxWidth: '90%', fontFamily: 'OpenSans', color: 'white' }}
                                textareaStyle={{ color: 'white' }}
                                inputStyle={{ color: 'white' }}
                                hintStyle={{ color: 'white' }}
                                hintText={this.state.email}
                                errorText={this.state.emailErro}
                                floatingLabelText={this.state.legendas.email}
                                floatingLabelStyle={{ color: 'white' }}
                                multiLine={false}
                                rows={1}
                                rowsMax={1}
                                value={this.state.email}
                                onChange={this.handleInputChangeEmail}
                            />
                        </div>
                        <div className="ui-g-3">
                            <TextField
                                style={{ maxWidth: '50%', fontFamily: 'OpenSans', color: 'white' }}
                                textareaStyle={{ color: 'white' }}
                                inputStyle={{ color: 'white' }}
                                hintStyle={{ color: 'white' }}
                                hintText={this.state.ddd}
                                errorText={this.state.dddErro}
                                floatingLabelText={this.state.legendas.ddd}
                                floatingLabelStyle={{ color: 'white' }}
                                multiLine={false}
                                rows={1}
                                rowsMax={1}
                                value={this.state.ddd}
                                onChange={this.handleInputChangeDdd}
                            />
                        </div>
                        <div className="ui-g-9">
                            <TextField
                                style={{ maxWidth: '90%', fontFamily: 'OpenSans', color: 'white' }}
                                textareaStyle={{ color: 'white' }}
                                inputStyle={{ color: 'white' }}
                                hintStyle={{ color: 'white' }}
                                hintText={this.state.telefone}
                                errorText={this.state.telefoneErro}
                                floatingLabelText={this.state.legendas.telefone}
                                floatingLabelStyle={{ color: 'white' }}
                                multiLine={false}
                                rows={1}
                                rowsMax={1}
                                value={this.state.telefone}
                                onChange={this.handleInputChangeTelefone}
                            />
                        </div>


                        <div className="ui-g-12">
                            <RaisedButton label={this.state.legendas.doar} primary={true} onTouchTap={this.guardar} />
                        </div>
                    </div>
                </div>
            </MuiThemeProvider>
        );
    }

}
export default GuardaHistoriaEAutor;


// WEBPACK FOOTER //
// ./src/componentes/guardahistoriaeautor/GuardaHistoriaEAutor.js